export const ACL_PERMISSIONS = {
  ADMIN_ACCESS: 'admin:access',
} as const;

export type AclPermission = (typeof ACL_PERMISSIONS)[keyof typeof ACL_PERMISSIONS];
